module.exports = __webpack_public_path__ + "static/media/Metamorphoses.5529048e.png";